import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const AppliedDiscountCouponIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M16.8839 25.0174L29.6639 12.2374C30.4451 11.4562 30.4451 10.1896 29.6639 9.40841L28.9567 8.70114C28.5661 8.31054 27.9356 8.33077 27.4387 8.57209C26.3203 9.11523 24.9345 8.9225 24.0059 7.9939C23.0773 7.06529 22.8846 5.67948 23.4277 4.56109C23.669 4.06419 23.6893 3.43375 23.2987 3.04314L22.5914 2.33591C21.8102 1.5547 20.5436 1.5547 19.7624 2.33591L6.98242 15.1159L16.8839 25.0174Z"
          fill="white"
        />
        <path
          d="M29.3146 12.5868L29.664 12.2374C30.4452 11.4562 30.4452 10.1896 29.664 9.40841L28.9567 8.70114C28.5661 8.31054 27.9356 8.33077 27.4387 8.57209C26.8461 8.85988 26.1784 8.94107 25.5435 8.81565L29.3146 12.5868Z"
          fill="#EDE8FF"
        />
        <path
          d="M23.1842 6.45634C23.0587 5.82137 23.1399 5.15369 23.4277 4.56109C23.669 4.06419 23.6893 3.43375 23.2987 3.04314L22.5914 2.33591C21.8102 1.5547 20.5437 1.5547 19.7624 2.33591L19.4131 2.68526L23.1842 6.45634Z"
          fill="#EDE8FF"
        />
        <path
          d="M6.98255 15.1152L2.33591 19.7619C1.5547 20.5431 1.5547 21.8097 2.3359 22.5909L3.04316 23.2981C3.43376 23.6887 4.06421 23.6685 4.56111 23.4272C5.6795 22.884 7.06531 23.0768 7.99391 24.0054C8.92251 24.934 9.11524 26.3198 8.5721 27.4382C8.33079 27.9351 8.31056 28.5655 8.70116 28.9561L9.40841 29.6634C10.1896 30.4446 11.4562 30.4446 12.2374 29.6634L16.8841 25.0167L6.98255 15.1152Z"
          fill="#CAB4FF"
        />
        <path
          d="M9.89983 17.1494C9.65576 16.9053 9.26003 16.9053 9.01595 17.1494C8.77187 17.3934 8.77187 17.7892 9.01595 18.0332L10.6662 19.6835C10.9103 19.9276 11.306 19.9276 11.5501 19.6835C11.7942 19.4394 11.7942 19.0437 11.5501 18.7996L9.89983 17.1494Z"
          fill="#000083"
        />
        <path
          d="M13.2003 20.4499C12.9563 20.2058 12.5605 20.2058 12.3165 20.4499C12.0724 20.6939 12.0724 21.0897 12.3165 21.3337L13.9667 22.984C14.2108 23.2281 14.6065 23.2281 14.8506 22.984C15.0947 22.7399 15.0947 22.3442 14.8506 22.1001L13.2003 20.4499Z"
          fill="#000083"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.1219 1.80558C22.0478 0.731475 20.3063 0.731474 19.2322 1.80558L1.80558 19.2322C0.731475 20.3063 0.731475 22.0478 1.80558 23.1219L3.22008 24.5364C3.36073 24.677 3.55149 24.7561 3.75041 24.7561C3.94932 24.7561 4.14008 24.677 4.28074 24.5364C5.15965 23.6575 6.58466 23.6575 7.46358 24.5364C8.3425 25.4153 8.3425 26.8403 7.46358 27.7192C7.32293 27.8599 7.24391 28.0507 7.24391 28.2496C7.24391 28.4485 7.32293 28.6392 7.46358 28.7799L8.87808 30.1944C9.95218 31.2685 11.6936 31.2685 12.7677 30.1944L30.1944 12.7677C31.2685 11.6936 31.2685 9.95218 30.1944 8.87808L28.7799 7.46356C28.487 7.17067 28.0121 7.17067 27.7192 7.46357C26.8403 8.34248 25.4153 8.34248 24.5364 7.46356C23.6574 6.58465 23.6574 5.15964 24.5364 4.28072C24.8293 3.98783 24.8293 3.51296 24.5364 3.22006M20.2929 2.86623C20.7812 2.37792 21.5729 2.37792 22.0612 2.86624L22.9984 3.80342C22.0335 5.2597 22.1926 7.24114 23.4757 8.52423C24.7588 9.80731 26.7402 9.96641 28.1965 9.00152L29.1337 9.93874C29.622 10.4271 29.622 11.2188 29.1337 11.7071L16.7956 24.0452L16.5008 23.7504C16.2568 23.5063 15.861 23.5063 15.617 23.7504C15.3729 23.9944 15.3729 24.3902 15.617 24.6342L15.9118 24.9291L11.7071 29.1337C11.2188 29.622 10.4271 29.622 9.93874 29.1337L9.00154 28.1965C9.96642 26.7403 9.80732 24.7588 8.52424 23.4757C7.24115 22.1926 5.25971 22.0335 3.80344 22.9984L2.86624 22.0612C2.37792 21.5729 2.37792 20.7812 2.86624 20.2929L7.07092 16.0882L7.3657 16.383C7.60978 16.6271 8.00551 16.6271 8.24958 16.383C8.49366 16.1389 8.49366 15.7432 8.24958 15.4991L7.9548 15.2043L20.2929 2.86623Z"
          fill="#000083"
        />
        <path
          d="M5.53036 1.96967C5.23747 1.67678 4.76259 1.67678 4.4697 1.96967C4.17681 2.26256 4.17681 2.73744 4.4697 3.03033L5.62355 4.18418C5.91644 4.47707 6.39131 4.47707 6.68421 4.18418C6.9771 3.89128 6.9771 3.41641 6.68421 3.12352L5.53036 1.96967Z"
          fill="#006DFF"
        />
        <path
          d="M10.5304 1.96968C10.8233 2.26257 10.8233 2.73744 10.5304 3.03034L9.37652 4.18418C9.08363 4.47708 8.60875 4.47708 8.31586 4.18418C8.02297 3.89129 8.02297 3.41642 8.31586 3.12352L9.46971 1.96968C9.7626 1.67678 10.2375 1.67678 10.5304 1.96968Z"
          fill="#006DFF"
        />
        <path
          d="M6.68418 6.8765C6.97707 6.5836 6.97707 6.10873 6.68418 5.81584C6.39128 5.52294 5.91641 5.52294 5.62352 5.81584L4.46967 6.96968C4.17678 7.26258 4.17678 7.73745 4.46967 8.03034C4.76256 8.32324 5.23744 8.32324 5.53033 8.03034L6.68418 6.8765Z"
          fill="#006DFF"
        />
        <path
          d="M8.31589 5.81583C8.60878 5.52294 9.08366 5.52294 9.37655 5.81583L10.5304 6.96968C10.8233 7.26257 10.8233 7.73744 10.5304 8.03034C10.2375 8.32323 9.76263 8.32323 9.46974 8.03034L8.31589 6.87649C8.023 6.5836 8.023 6.10872 8.31589 5.81583Z"
          fill="#006DFF"
        />
        <path
          d="M4 13C4.55228 13 5 12.5523 5 12C5 11.4477 4.55228 11 4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13Z"
          fill="#006DFF"
        />
        <path
          d="M18.0782 8.88146C18.0101 8.47288 17.6237 8.19686 17.2151 8.26496C16.8066 8.33306 16.5306 8.71948 16.5987 9.12806L18.2149 18.8255C18.283 19.2341 18.6694 19.5101 19.078 19.442C19.4866 19.3739 19.7626 18.9875 19.6945 18.5789L18.0782 8.88146Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7554 12.5271C11.9113 13.3712 11.9113 14.7398 12.7554 15.5839C13.5995 16.428 14.9681 16.428 15.8122 15.5839C16.6563 14.7398 16.6563 13.3712 15.8122 12.5271C14.9681 11.683 13.5995 11.683 12.7554 12.5271ZM13.8161 14.5232C13.5577 14.2649 13.5577 13.8461 13.8161 13.5877C14.0744 13.3294 14.4932 13.3294 14.7515 13.5877C15.0098 13.8461 15.0098 14.2649 14.7515 14.5232C14.4932 14.7815 14.0744 14.7815 13.8161 14.5232Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4806 12.1226C19.6365 12.9667 19.6365 14.3352 20.4806 15.1793C21.3247 16.0235 22.6933 16.0235 23.5374 15.1794C24.3815 14.3352 24.3815 12.9667 23.5374 12.1226C22.6933 11.2785 21.3247 11.2785 20.4806 12.1226ZM21.5413 14.1187C21.283 13.8604 21.283 13.4415 21.5413 13.1832C21.7996 12.9249 22.2184 12.9249 22.4767 13.1832C22.7351 13.4415 22.7351 13.8604 22.4767 14.1187C22.2184 14.377 21.7996 14.377 21.5413 14.1187Z"
          fill="#006DFF"
        />
        <path
          d="M29 20C29 20.5523 28.5523 21 28 21C27.4478 21 27 20.5523 27 20C27 19.4477 27.4478 19 28 19C28.5523 19 29 19.4477 29 20Z"
          fill="#006DFF"
        />
        <path
          d="M27.5304 23.9697C27.8233 24.2626 27.8233 24.7374 27.5304 25.0303L26.3765 26.1842C26.0836 26.4771 25.6088 26.4771 25.3159 26.1842C25.023 25.8913 25.023 25.4164 25.3159 25.1235L26.4697 23.9697C26.7626 23.6768 27.2375 23.6768 27.5304 23.9697Z"
          fill="#006DFF"
        />
        <path
          d="M23.6842 27.8158C23.9771 28.1087 23.9771 28.5836 23.6842 28.8765L22.5303 30.0303C22.2374 30.3232 21.7626 30.3232 21.4697 30.0303C21.1768 29.7374 21.1768 29.2626 21.4697 28.9697L22.6235 27.8158C22.9164 27.5229 23.3913 27.5229 23.6842 27.8158Z"
          fill="#006DFF"
        />
        <path
          d="M21.4697 23.9697C21.7626 23.6768 22.2375 23.6768 22.5304 23.9697L23.6842 25.1235C23.9771 25.4164 23.9771 25.8913 23.6842 26.1842C23.3913 26.4771 22.9164 26.4771 22.6235 26.1842L21.4697 25.0303C21.1768 24.7374 21.1768 24.2626 21.4697 23.9697Z"
          fill="#006DFF"
        />
        <path
          d="M25.3159 27.8158C25.6088 27.5229 26.0837 27.5229 26.3766 27.8158L27.5304 28.9697C27.8233 29.2626 27.8233 29.7374 27.5304 30.0303C27.2375 30.3232 26.7626 30.3232 26.4697 30.0303L25.3159 28.8765C25.023 28.5836 25.023 28.1087 25.3159 27.8158Z"
          fill="#006DFF"
        />
      </svg>
    );
  }
);
export default AppliedDiscountCouponIcon;
